import Menus from "@/components/menus/Menus";
import Pagination from "@/components/pagination/Pagination";
import { getMenus } from "@/services/menuService";
import { MenuJsonItem } from "@/types/types";
import Head from "next/head";

interface PageProps {
  menus: MenuJsonItem[];
  currentPage: number;
  totalPages: number;
}

export async function getServerSideProps(
  context: any
): Promise<{ props: PageProps }> {
  const { query } = context;
  const { page = 1, limit = 51 } = query;

  let response = await getMenus(
    "",
    parseInt(page),
    parseInt(limit),
    undefined,
    undefined,
    undefined
  );

  return {
    props: {
      menus: response.data || [],
      currentPage: response.currentPage,
      totalPages: response.totalPages,
    },
  };
}

const MenusPage: React.FC<PageProps> = ({ menus, currentPage, totalPages }) => {
  return (
    <div>
      <Head>
        <title>The Best Restaurants Right Now | Qr menu</title>
        <meta
          name="description"
          content={`Explore the top restaurants. We provide latest menu and price information for the leading restaurants menu price.`}
        />
      </Head>
      <div
        className="bg-cover bg-center min-h-[35vh] flex items-center justify-center py-20"
        style={{
          backgroundImage: `url('https://dopweb-repository.s3.us-west-2.amazonaws.com/qrmenu/mydop-images/img5d5db67a-221c-4e9d-87fb-f2d56bd9a51e.webp')`,
        }}
      >
        <div className="container mx-auto text-center">
          <div className="flex flex-wrap justify-center">
            <div className="w-full px-4">
              <h1 className="text-4xl font-bold text-black mb-4">
                The best restaurants
              </h1>
              <p className="text-xl text-black">
                Explore the Best Menu Selections of Restaurants
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container mx-auto px-4 mb-12 max-w-[1225px]">
        <h2 className="text-2xl font-semibold text-center my-8">
          Browse restaurant menus
        </h2>
        <Menus menus={menus} />
        <Pagination currentPage={currentPage} totalPages={totalPages} />
      </div>
    </div>
  );
};

export default MenusPage;
